// extracted by mini-css-extract-plugin
export default {"textContainer":"retailCaseStudy_textContainer__-IG+O","overlay":"retailCaseStudy_overlay__z8xiC","heading":"retailCaseStudy_heading__ofXrc"};